import React, { useLayoutEffect, useRef, useState } from 'react';
import './index.css';
import siteConfig from '../../configuration/siteConfiguration';
import { useIsMobile } from '../../hooks/useMediaQuery';

// Natural (unscaled) size of the compact phone diagram, in CSS px.
// The diagram is drawn at this size and scaled to fill the available width.
const MOBILE_STAGE_W = 368;
const MOBILE_STAGE_H = 352;
const MOBILE_MAX_SCALE = 1.25;

const FeaturePlanet = ({ competencyPills }) => {
    const isMobile = useIsMobile();
    const frameRef = useRef(null);
    const [scale, setScale] = useState(1);

    // Phones: scale the diagram to the frame width so the cards stay as large
    // as possible on every phone (320px to 768px) without overflowing.
    useLayoutEffect(() => {
        if (!isMobile || !frameRef.current) return undefined;
        const frame = frameRef.current;
        const update = () => {
            const w = frame.clientWidth;
            if (w) setScale(Math.min(MOBILE_MAX_SCALE, w / MOBILE_STAGE_W));
        };
        update();
        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', update);
            return () => window.removeEventListener('resize', update);
        }
        const ro = new ResizeObserver(update);
        ro.observe(frame);
        return () => ro.disconnect();
    }, [isMobile]);

    const planet = (
        <div className='fpc-container'>
            <div className='fpc-core-ring-holder'>
                <div className="fpc-core-ring-4">
                    {competencyPills.map((pill, index) => {
                        if (pill.type == 'card') {  // Only render cards
                            return (
                                <div key={`comp-pill-cntr-${index}`} style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-card-on-4" style={{ ...pill.style }}>
                                        <div className='fpc-core-card-on-4-bar'></div>
                                        {pill.text}
                                    </div>
                                </div>
                            )
                        }
                        if (pill.type == 'icon') {
                            return (
                                <div key={`comp-pill-cntr-${index}`} style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-icon-on-4" style={{ ...pill.style }}>
                                        <img src={pill.icon} alt="" />
                                    </div>
                                </div>
                            )
                        }
                        if (pill.type == 'dot-icon') {
                            return (
                                <div key={`comp-pill-cntr-${index}`} style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-dot-icon-on-4" style={{ ...pill.style }}>
                                        <img src={pill.icon} alt="" />
                                    </div>
                                </div>
                            )
                        }
                        return null;
                    })}
                </div>
                <div className="fpc-core-ring-3"></div>
                <div className="fpc-core-ring-2">
                    <div style={{ position: 'absolute' }}>
                        <img src={`${siteConfig.assetBaseUrl}/logos/core-capibilities.png`} className='fpc-core-capabilities-logo' alt="Cognitva core capabilities" />
                    </div>
                </div>
            </div>
        </div>
    );

    if (isMobile) {
        return (
            <div
                className="fpc-mobile-frame"
                ref={frameRef}
                style={{ height: `${MOBILE_STAGE_H * scale}px` }}
            >
                <div
                    className="fpc-mobile-stage"
                    style={{
                        width: `${MOBILE_STAGE_W}px`,
                        height: `${MOBILE_STAGE_H}px`,
                        transform: `translateX(-50%) scale(${scale})`,
                    }}
                >
                    {planet}
                </div>
            </div>
        );
    }

    return planet;
};

export default FeaturePlanet;